import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=3af6fb3e&scoped=true&"
import script from "./Segment.vue?vue&type=script&lang=js&"
export * from "./Segment.vue?vue&type=script&lang=js&"
import style0 from "./Segment.vue?vue&type=style&index=0&id=3af6fb3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6fb3e",
  null
  
)

export default component.exports